import { render } from "./client-shutdown-modal.vue?vue&type=template&id=31df103c&scoped=true&ts=true"
import script from "./client-shutdown-modal.vue?vue&type=script&lang=ts"
export * from "./client-shutdown-modal.vue?vue&type=script&lang=ts"

import "./client-shutdown-modal.vue?vue&type=style&index=0&id=31df103c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31df103c"]])

export default __exports__